import {ChangeDetectionStrategy, Component, inject} from '@angular/core';

import {AuthService} from '@brunata-angular/auth';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {CookieService} from 'ngx-cookie-service';
import {environment} from 'src/environments/environment';
import {logOut} from 'src/app/state/actions';

@Component({
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [],
    template: ``,
})
export class LogOutComponent {
    private readonly authService = inject(AuthService);
    private readonly router = inject(Router);
    private readonly store = inject(Store);
    private readonly cookieService = inject(CookieService);

    constructor() {
        const idToken = this.cookieService.get('id_token');
        if (idToken !== '') {
            this.authService.logOut();
            this.store.dispatch(logOut());
            const params = new URLSearchParams({
                /* eslint-disable @typescript-eslint/naming-convention */
                id_token_hint: idToken,
                post_logout_redirect_uri: window.location.origin,
                /* eslint-enable @typescript-eslint/naming-convention */
            });
            window.location.href = `${environment.oauthUrl}/logout?${params.toString()}`;
            return;
        }

        this.authService.logOut();
        this.store.dispatch(logOut());
        void this.router.navigate(['/']);
    }
}
